export const DEMO_OUTPUT_URL = '/demo-reel.mp4';

export const DEMO_REQUIRED_FOOTAGE = Object.freeze([
  {
    id: 'turn-camera', title: 'Turn Towards Camera', location: 'Bedroom',
    phonePosition: 'Put the phone vertically on the tripod. Place it around waist height.',
    frame: 'Show your body from your knees upwards.', startPosition: 'Stand with your side facing the phone.',
    steps: ['Put the phone on the tripod.', 'Stand 2 metres away with your side facing the phone.', 'Press record.', 'Wait 2 seconds.', 'Slowly turn towards the phone.', 'Look at the phone.', 'Wait 2 seconds.', 'Stop recording.'],
    eyes: 'Look at the camera after you turn.', expression: 'Relaxed.', duration: '8–10 seconds', libraryMatch: null
  },
  {
    id: 'walk-camera', title: 'Walk Towards Camera', location: 'Bedroom',
    phonePosition: 'Put the phone vertically on the tripod. Place it around waist height.',
    frame: 'Show your full body.', startPosition: 'Stand at the back of the room.',
    steps: ['Put the phone on the tripod.', 'Stand at the back of the room.', 'Press record.', 'Wait 2 seconds.', 'Walk slowly towards the phone.', 'Stop walking.', 'Wait 2 seconds.', 'Stop recording.'],
    eyes: 'Look slightly past the camera.', expression: 'Relaxed.', duration: '8–10 seconds',
    libraryMatch: { assetId: 'library-bedroom-walk-01', score: 0.94 }
  },
  {
    id: 'touch-hair', title: 'Touch Your Hair', location: 'Bedroom',
    phonePosition: 'Put the phone vertically on the tripod. Place it at chest height.',
    frame: 'Show your head and upper body.', startPosition: 'Stand 1 metre away and face the phone.',
    steps: ['Put the phone on the tripod.', 'Stand 1 metre away.', 'Press record.', 'Wait 2 seconds.', 'Lift your right hand.', 'Slowly touch your hair.', 'Wait 2 seconds.', 'Stop recording.'],
    eyes: 'Look at the camera.', expression: 'Small smile.', duration: '7–9 seconds', libraryMatch: null
  }
]);

const clone = (value) => JSON.parse(JSON.stringify(value));

export function createDemoAnalysis() {
  return {
    title: 'Bedroom Outfit Transition', duration: 8.6, orientation: 'vertical',
    referenceScenes: [
      { id: 'scene-1', start: 0, end: 2.4, action: 'Turn towards camera', frame: 'medium full body' },
      { id: 'scene-2', start: 2.4, end: 5.7, action: 'Walk towards camera', frame: 'full body' },
      { id: 'scene-3', start: 5.7, end: 8.6, action: 'Touch hair', frame: 'upper body' }
    ],
    transitionStructure: 'Three clean cuts timed to the beat', cutTiming: [2.4, 5.7],
    audioTiming: 'Main movement lands on each beat', textTiming: 'Title appears during the opening shot',
    requiredFootage: clone(DEMO_REQUIRED_FOOTAGE)
  };
}

export function createDemoProject(id, now = new Date().toISOString()) {
  return {
    id, title: 'Bedroom Outfit Transition', createdAt: now, updatedAt: now, status: 'draft',
    clipsComplete: 0, clipsRequired: 0, reference: null, analysis: null, requiredClips: [],
    assets: [], job: null, finishedVideoUrl: null, changeRequests: []
  };
}

export function analyseDemoProject(project) {
  const analysis = createDemoAnalysis();
  const requiredClips = analysis.requiredFootage.map((clip) => ({
    ...clip, source: clip.libraryMatch ? 'library' : 'filming',
    status: clip.libraryMatch ? 'approved' : 'pending', attempts: 0,
    validation: clip.libraryMatch ? { outcome: 'pass', reused: true } : null
  }));
  const filmed = requiredClips.filter((clip) => clip.source === 'filming');
  return { ...project, title: analysis.title, status: filmed.length ? 'filming_required' : 'filming_complete', analysis, requiredClips, clipsRequired: filmed.length, clipsComplete: 0, updatedAt: new Date().toISOString() };
}

export function pendingFilmingClips(project) {
  return (project.requiredClips || []).filter((clip) => clip.source === 'filming' && clip.status !== 'approved');
}

export function validateDemoClip(clip) {
  const attempt = Number(clip.attempts || 0) + 1;
  if (clip.id === 'touch-hair' && attempt === 1) {
    return { outcome: 'retake', attempt, reason: 'The top of your head is cut off.', singleInstruction: 'Move the phone slightly further away and repeat the same clip.' };
  }
  return { outcome: 'pass', attempt, reason: null, singleInstruction: null };
}

export function seedDemoProjects(now = new Date().toISOString()) {
  return [
    { ...createDemoProject('demo-ready', now), title: 'Hair Transition', status: 'ready', clipsComplete: 2, clipsRequired: 2, finishedVideoUrl: DEMO_OUTPUT_URL },
    { ...createDemoProject('demo-editing', new Date(Date.now() - 86400000).toISOString()), title: 'Walking Reel', status: 'editing', clipsComplete: 2, clipsRequired: 2, job: { id: 'seed-job', status: 'editing', polls: 0 } }
  ];
}

